export default "__VITE_ASSET__CFM0EBcq__"